import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EasyDialog } from '@shared';
import { Router } from '@angular/router';
import { AuditProgramResponse } from 'app/model/audit-program-response-dto';
import { CommonDTO } from 'app/model/common-dto';
import { CommonService } from 'app/service/common.service';
import { CustomMessages } from '../custom-messages/custom-messages';
import { SidebarComponent } from 'app/theme/admin-layout/sidebar/sidebar.component';
import { ApprovalDetailsResponse } from 'app/model/approval-details-response';
import { TransactionDetailsResponse } from 'app/model/transaction-details-dto';

@Component({
  selector: 'app-workflowlist',
  templateUrl: './workflowlist.component.html',
  styleUrls: ['./workflowlist.component.scss']
})
export class WorkflowlistComponent implements OnInit {
  auditProgramDetail: AuditProgramResponse;
  commonDto: CommonDTO = new CommonDTO();
  approvalDetailsList: ApprovalDetailsResponse[];
  responseList = [];
  transactionDetailsList: TransactionDetailsResponse[];

  constructor(private route: Router, private commonService: CommonService, private customMessage: CustomMessages,
    private sideBarComponent: SidebarComponent,
    private dialogRef: MatDialogRef<WorkflowlistComponent>,
    @Inject(MAT_DIALOG_DATA) public recievedData: any) {
    this.auditProgramDetail = recievedData.auditProgramDetail;
  }
  ngOnInit() {
    this.getApprovalDetails();
    this.getTransactionDetails();
  }
  closePopup() {
    this.dialogRef.close(true);
    return false;
  }
  getApprovalDetails() {
    this.commonDto.reqId = this.auditProgramDetail.requisitionId;
    this.commonDto.wfType = this.auditProgramDetail.wfType;
    this.sideBarComponent.showHideLoader(true);
    this.commonService.getApprovalDetails(this.commonDto)
      .subscribe((data: any) => {
        if (data == null) {
          this.approvalDetailsList = [];
        }
        else {
          this.responseList = data;
          this.approvalDetailsList = this.responseList;
          this.sideBarComponent.showHideLoader(false);
        }
      }, (error) => {
        this.sideBarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      });

  }

  getTransactionDetails() {
    this.commonDto.reqId = this.auditProgramDetail.requisitionId;
    this.commonDto.wfType = this.auditProgramDetail.wfType;
    this.sideBarComponent.showHideLoader(true);
    this.commonService.getTransactionDetails(this.commonDto)
      .subscribe((data: TransactionDetailsResponse[]) => {
        if (data.length < 1) {
          this.transactionDetailsList = [];
        }
        else {
          this.responseList = data;
          this.transactionDetailsList = this.responseList;
          this.sideBarComponent.showHideLoader(false);
        }

      }, (error) => {
        this.sideBarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      });

  }
}
